<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content class="content">{{message}}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button cdkFocusInitial (click)="cancel()">取消</button>
  <button mat-button (click)="confirm()">确定</button>
</mat-dialog-actions>
